class TaxonomyNavigation {
	parentActiveClass = 'menu-taxonomy--active';

	childActiveClass = 'menu-taxonomy--active-children';

	constructor(el) {
		this.parentTerms = el.querySelectorAll('.menu-taxonomy--parent');
		this.childTerms = el.querySelectorAll('.menu-taxonomy--children-list');
		this.additionalChildren = el.querySelectorAll('.menu-taxonomy--additional-children');
		this.init();
	}

	init() {
		if (!this.parentTerms.length || !this.childTerms.length) {
			return;
		}

		this.activateParent(this.parentTerms[0]);

		this.parentTerms.forEach((parent) => {
			parent.addEventListener('mouseenter', () => {
				this.activateParent(parent);
			});

			parent.addEventListener('focusin', () => {
				this.activateParent(parent);
			});

			const parentTrigger = parent.querySelector('.menu-taxonomy--link');

			if (parentTrigger) {
				parentTrigger.addEventListener('click', (event) => {
					event.preventDefault();
					this.activateParent(parent);
				});
			}
		});
	}

	activateParent(parent) {
		const parentId = parent.dataset.id;

		this.parentTerms.forEach((term) => term.classList.remove(this.parentActiveClass));

		this.childTerms.forEach((children) =>
			children.classList.remove(this.childActiveClass)
		);

		this.additionalChildren.forEach((children) =>
			children.classList.remove(this.childActiveClass)
		);

		parent.classList.add(this.parentActiveClass);

		const matchedChildren = Array.from([...this.childTerms, ...this.additionalChildren]).filter(
			(children) => children.dataset.parent === parentId
		);

		matchedChildren.forEach((child) => {
			child.classList.add(this.childActiveClass);

			if (child.classList.contains('menu-taxonomy--additional-children')) {
				child.querySelectorAll('.mega-featured-posts').forEach((featuredPostsEl) => {
					if (featuredPostsEl._megaFeaturedPosts) {
						featuredPostsEl._megaFeaturedPosts.initSlider();
					}
				});
			}
		});
	}
}

export default TaxonomyNavigation;
